import { render } from "./ViewMyAttendance.vue?vue&type=template&id=0dcb785a&scoped=true"
import script from "./ViewMyAttendance.vue?vue&type=script&lang=js"
export * from "./ViewMyAttendance.vue?vue&type=script&lang=js"

import "./view-my-attendance.scss?vue&type=style&index=0&id=0dcb785a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcb785a"]])

export default __exports__